import { Controller } from "stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = [
    "taskDetails",
    "assignedCard",
    "emptyState",
    "collectionTitle",
    "dropdown",
  ];
  static values = {
    taskId: Number,
    detailsUrl: String, // URL template like "/admin/programs/123/editor/questionnaires/:id?task_id=456"
  };

  connect() {
    // Listen for the custom event from AsyncDropdown
    this.boundLoadDetails = this.loadDetails.bind(this);

    if (this.hasDropdownTarget) {
      this.dropdownTarget.addEventListener(
        "promote:async-dropdown:change",
        this.boundLoadDetails,
      );
    }
  }

  disconnect() {
    if (this.hasDropdownTarget) {
      this.dropdownTarget.removeEventListener(
        "promote:async-dropdown:change",
        this.boundLoadDetails,
      );
    }
  }

  loadDetails(event) {
    const questionnaireId = event.detail.value;
    if (!questionnaireId) return;

    // Interpolate ID into URL template
    const url = this.detailsUrlValue.replace(":id", questionnaireId);

    // Make AJAX request for questionnaire details
    Rails.ajax({
      url: url,
      type: "GET",
      dataType: "script",
    });
  }

  reset() {
    if (this.hasAssignedCardTarget) {
      this.assignedCardTarget.innerHTML = "";
      this.assignedCardTarget.classList.add("hidden");
    }
    if (this.hasEmptyStateTarget) {
      this.emptyStateTarget.classList.remove("hidden");
    }
    if (this.hasCollectionTitleTarget) {
      this.collectionTitleTarget.value = "";
      this.collectionTitleTarget.required = false;
    }
  }
}
